import React from 'react';
import PropTypes from 'prop-types';
import Button from "UI/Button";
import ButtonGroup from "UI/ButtonGroup";

import Sizes from 'UI/sizes';

export default class TextAlign extends React.Component
{
    static propTypes = {
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    render()
    {
        return <ButtonGroup onChange={this.props.onChange}>
            <Button value="left" active={this.props.value === 'left'} size={Sizes.EXTRA_SMALL}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className='w-4 text-black fill-current'>
                    <path d="M 6 9 A 2.0002 2.0002 0 1 0 6 13 L 34 13 A 2.0002 2.0002 0 1 0 34 9 L 6 9 z M 6 22 A 2.0002 2.0002 0 1 0 6 26 L 42 26 A 2.0002 2.0002 0 1 0 42 22 L 6 22 z M 7 35 A 2.0002 2.0002 0 1 0 7 39 L 27 39 A 2.0002 2.0002 0 1 0 27 35 L 7 35 z" />
                </svg>
            </Button>
            <Button value="center" active={this.props.value === 'center'} size={Sizes.EXTRA_SMALL}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className='w-4 text-black fill-current'>
                    <path d="M 10 9 A 2.0002 2.0002 0 1 0 10 13 L 38 13 A 2.0002 2.0002 0 1 0 38 9 L 10 9 z M 6 22 A 2.0002 2.0002 0 1 0 6 26 L 42 26 A 2.0002 2.0002 0 1 0 42 22 L 6 22 z M 14 35 A 2.0002 2.0002 0 1 0 14 39 L 34 39 A 2.0002 2.0002 0 1 0 34 35 L 14 35 z" />
                </svg>
            </Button>
            <Button value="right" active={this.props.value === 'right'} size={Sizes.EXTRA_SMALL}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className='w-4 text-black fill-current'>
                    <path d="M 14 9 A 2.0002 2.0002 0 1 0 14 13 L 42 13 A 2.0002 2.0002 0 1 0 42 9 L 14 9 z M 6 22 A 2.0002 2.0002 0 1 0 6 26 L 42 26 A 2.0002 2.0002 0 1 0 42 22 L 6 22 z M 22 35 A 2.0002 2.0002 0 1 0 22 39 L 42 39 A 2.0002 2.0002 0 1 0 42 35 L 22 35 z" />
                </svg>
            </Button>
        </ButtonGroup>;
    }
}
